import React from "react";
import ButtonPrimary from "./ButtonPrimary";
import { IoAlertCircleOutline } from "react-icons/io5";
import { VscFilePdf } from "react-icons/vsc";
import { MdOutlineLibraryAdd } from "react-icons/md";
export default function ButtonSelectedItems({
  pdfClick,
  reportClick,
  addClick,
  addTitle,
}) {
  return (
    <div className="row-jcfe-my2" style={{ paddingBottom: "2rem" }}>
      <ButtonPrimary
        className={"icon-txt-button2"}
        text={
          <>
            <VscFilePdf />
          </>
        }
        onClick={pdfClick}
      />
      <ButtonPrimary
        className={"icon-txt-button2"}
        text={
          <>
            <IoAlertCircleOutline />
            {"Report Student"}
          </>
        }
        onClick={reportClick}
      />
      <ButtonPrimary
        className={"icon-txt-button2"}
        text={
          <>
            <MdOutlineLibraryAdd />
            {addTitle}
          </>
        }
        onClick={addClick}
      />
    </div>
  );
}
